"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callApiBufferExtension = callApiBufferExtension;
const iris_rtc_api_type_gen_1 = require("../util/iris_rtc_api_type_gen");
function callApiBufferExtension(func_name, data, buffer) {
    switch (func_name) {
        case iris_rtc_api_type_gen_1.IMEDIAENGINE_PUSHVIDEOFRAME_4e544e2:
            if (typeof (data === null || data === void 0 ? void 0 : data.frame) === 'object') {
                data.frame.buffer = buffer;
            }
            break;
        case iris_rtc_api_type_gen_1.IRTCENGINE_SENDSTREAMMESSAGE_8715a45:
            if (buffer) {
                data.data = buffer[0];
            }
            break;
        case iris_rtc_api_type_gen_1.IRTCENGINEEX_SENDSTREAMMESSAGEEX_0c34857:
            if (buffer) {
                data.data = buffer[0];
            }
            break;
    }
    return data;
}
